import { schemas } from '@convergence/client';
import { useQuery } from '@tanstack/react-query';
import { fetch } from '../../api/fetch';

export function getCheckoutSesesion(sessionId: string) {
  return fetch(
    `/payment/stripe/session?session_id=${sessionId}`,
    { method: 'GET' },
    schemas.CheckoutSession
  );
}

export function useCheckoutSession(sessionId: string | null) {
  return useQuery({
    queryKey: ['checkout', sessionId],
    enabled: !!sessionId,
    queryFn: () => getCheckoutSesesion(sessionId!)
  });
}
